import React from "react";
import { Outlet } from "react-router-dom";
import Shearchbar from "./Shearchbar";

// Header ek hi baar mount hota hai, sirf neeche ka page badalta hai
const MainLayout = () => {
  return (
    <>
      <header>
        <Shearchbar />
      </header>
      <Outlet />
    </>
  );
};

export default MainLayout;